"use client"
import Link from "next/link";

import badge1Locked from "../../../../../public/referral/dashboard/icons/First Referral - faded.webp"
import badge1Unlocked from "../../../../../public/referral/dashboard/icons/First Referral.webp"
import badge2Locked from "../../../../../public/referral/dashboard/icons/Silver Advocate - faded.webp"
import badge2Unlocked from "../../../../../public/referral/dashboard/icons/Silver Advocate.webp"
import badge3Locked from "../../../../../public/referral/dashboard/icons/Gold Ambassador - faded.webp"
import badge3Unlocked from "../../../../../public/referral/dashboard/icons/Gold Ambassador.webp"
import badge4Locked from "../../../../../public/referral/dashboard/icons/Community Builder  - faded.webp"
import badge4Unlocked from "../../../../../public/referral/dashboard/icons/Community Builder.webp"
import badge5Locked from "../../../../../public/referral/dashboard/icons/Platinum Ambassador - faded.webp"
import badge5Unlocked from "../../../../../public/referral/dashboard/icons/Platinum Ambassador.webp"

const HEADING = 'Get Noticed. Get Rewarded.';
const SUB_HEADING = 'Compete, earn badges, and get recognized on the BeSocial platform.';
const LEADERBOARD_LABEL = 'Leaderboard';
const MILESTONE_LABEL = 'Milestone Badges';

const badgeStyle: Record<string, { bg: string; text: string }> = {
  'First Referral':      { bg: '#1F5FE0', text: '#FFFFFF' },
  'Silver Advocate':     { bg: '#9CA3AF', text: '#FFFFFF' },
  'Gold Ambassador':     { bg: '#E0B020', text: '#FFFFFF' },
  'Community Builder':   { bg: '#E0B020', text: '#FFFFFF' },
  'Platinum Ambassador': { bg: '#FFC107', text: '#1A325D' },
};

const FALLBACK_BADGE_STYLE = { bg: '#E2E8F0', text: '#1A325D' };

function getBadgeLabel(badge: string) {
  if (badge === 'First Referral') return badge;
  if (badge === 'Community Builder') return badge;
  return badge?.split(' ')[0] || badge;
}

function getBadgeStyle(badge: string) {

  return badgeStyle[badge] || FALLBACK_BADGE_STYLE;
}

// Each milestone keeps both unlocked + locked (faded) variants so the UI
// can swap based on user progress.
const milestones = [
  { label: 'First\nReferral',       badge: 'First Referral',      unlocked: badge1Unlocked?.src, locked: badge1Locked?.src },
  { label: 'Silver\nAdvocate',      badge: 'Silver Advocate',     unlocked: badge2Unlocked?.src, locked: badge2Locked?.src },
  { label: 'Gold\nAmbassador',      badge: 'Gold Ambassador',     unlocked: badge3Unlocked?.src, locked: badge3Locked?.src },
  { label: 'Community\nBuilder',    badge: 'Community Builder',   unlocked: badge4Unlocked?.src, locked: badge4Locked?.src },
  { label: 'Platinum\nAmbassador',  badge: 'Platinum Ambassador', unlocked: badge5Unlocked?.src, locked: badge5Locked?.src },
];

// Minimum referrals needed to unlock each milestone — matches the dashboard
// page tier thresholds.
const MILESTONE_THRESHOLD: Record<string, number> = {
  'First Referral': 1,
  'Silver Advocate': 2,
  'Gold Ambassador': 3,
  'Community Builder': 5,
  'Platinum Ambassador': 10,
};

const benefitItems = [
  'Public recognition on BeSocial Platform',
  'Monthly & quarterly rankings',
];

// Individual social share icons; add or remove entries as needed.
const SHARE_LINKS: Array<{ name: string; url?: string; icon: string; disabled?: boolean }> = [
  {
    name: 'Share',
    icon: 'https://amityonline.com/_s/svg_1_911b80080c.svg',
    disabled: true,
  },
  {
    name: 'Facebook',
    icon: 'https://amityonline.com/_s/image_92_4f5e368df8.svg',
    url: 'https://www.facebook.com/sharer/sharer.php?u=https://amityonline.com/referral',
  },
  {
    name: 'LinkedIn',
    icon: 'https://amityonline.com/_s/image_96_9754063fe0.svg',
    url: 'https://www.linkedin.com/sharing/share-offsite/?url=https://amityonline.com/referral',
  },
  {
    name: 'WhatsApp',
    icon: 'https://amityonline.com/_s/image_95_7b077bec36.svg',
    url: 'https://api.whatsapp.com/send?text=Check%20out%20this%20referral%20program%20at%20Amity%20Online:%20https://amityonline.com/referral',
  },
];

function CrownSvg({ color }: { color: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
<path d="M9.63501 2.72169C9.67098 2.65636 9.72382 2.60188 9.78802 2.56394C9.85222 2.526 9.92543 2.50598 10 2.50598C10.0746 2.50598 10.1478 2.526 10.212 2.56394C10.2762 2.60188 10.329 2.65636 10.365 2.72169L12.825 7.39169C12.8837 7.49982 12.9656 7.59363 13.0648 7.66637C13.164 7.73911 13.2781 7.78898 13.3988 7.8124C13.5196 7.83582 13.6441 7.83221 13.7633 7.80183C13.8825 7.77145 13.9935 7.71505 14.0883 7.63669L17.6525 4.58335C17.7209 4.5277 17.8052 4.4952 17.8933 4.49052C17.9814 4.48584 18.0687 4.50922 18.1426 4.55731C18.2165 4.60539 18.2733 4.67569 18.3047 4.75809C18.3362 4.8405 18.3406 4.93074 18.3175 5.01585L15.9558 13.5542C15.9076 13.7289 15.8038 13.8831 15.66 13.9935C15.5163 14.1039 15.3404 14.1644 15.1592 14.1659H4.84167C4.66029 14.1646 4.48427 14.1042 4.34033 13.9938C4.1964 13.8834 4.09242 13.729 4.04417 13.5542L1.68334 5.01669C1.66022 4.93158 1.66469 4.84133 1.69613 4.75893C1.72756 4.67653 1.78433 4.60622 1.85826 4.55814C1.93219 4.51006 2.01947 4.48667 2.10754 4.49135C2.19561 4.49603 2.27992 4.52854 2.34834 4.58419L5.91167 7.63752C6.00651 7.71589 6.11751 7.77229 6.23673 7.80267C6.35594 7.83305 6.4804 7.83666 6.60117 7.81323C6.72195 7.78981 6.83604 7.73994 6.93525 7.6672C7.03447 7.59446 7.11634 7.50065 7.17501 7.39252L9.63501 2.72169Z" stroke="#FFC107" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M4.16666 17.5H15.8333" stroke="#FFC107" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  );
}

function MedalSvg({ color }: { color: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
<path d="M12.8975 10.7417L14.16 17.8467C14.1741 17.9304 14.1624 18.0163 14.1264 18.0932C14.0903 18.17 14.0317 18.2339 13.9583 18.2765C13.8849 18.3191 13.8003 18.3383 13.7157 18.3315C13.6311 18.3246 13.5506 18.2922 13.485 18.2384L10.5017 15.9992C10.3577 15.8916 10.1827 15.8335 10.0029 15.8335C9.82315 15.8335 9.64819 15.8916 9.50417 15.9992L6.51584 18.2375C6.45027 18.2912 6.36989 18.3237 6.28542 18.3305C6.20095 18.3373 6.1164 18.3182 6.04306 18.2758C5.96972 18.2333 5.91107 18.1695 5.87494 18.0928C5.83881 18.0162 5.82691 17.9303 5.84084 17.8467L7.10251 10.7417" stroke="#D4AF37" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M10 11.6667C12.7614 11.6667 15 9.42817 15 6.66675C15 3.90532 12.7614 1.66675 10 1.66675C7.23858 1.66675 5 3.90532 5 6.66675C5 9.42817 7.23858 11.6667 10 11.6667Z" stroke="#D4AF37" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  );
}

function ShieldSvg({ color }: { color: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
<path d="M16.6667 10.8333C16.6667 15 13.75 17.0833 10.2833 18.2916C10.1018 18.3531 9.90462 18.3502 9.72501 18.2833C6.25001 17.0833 3.33334 15 3.33334 10.8333V4.99997C3.33334 4.77895 3.42114 4.56699 3.57742 4.41071C3.7337 4.25443 3.94566 4.16663 4.16668 4.16663C5.83334 4.16663 7.91668 3.16663 9.36668 1.89997C9.54322 1.74913 9.7678 1.66626 10 1.66626C10.2322 1.66626 10.4568 1.74913 10.6333 1.89997C12.0917 3.17497 14.1667 4.16663 15.8333 4.16663C16.0544 4.16663 16.2663 4.25443 16.4226 4.41071C16.5789 4.56699 16.6667 4.77895 16.6667 4.99997V10.8333Z" stroke="#9CA3AF" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  );
}

const GOLD = '#E0A100';
const SILVER = '#9CA3AF';

function RankIcon({ tier }: { tier: string }) {
  if (tier?.startsWith('Platinum')) return <CrownSvg color={GOLD} />;
  if (tier?.startsWith('Gold')) return <MedalSvg color={GOLD} />;
  if (tier?.startsWith('Community')) return <MedalSvg color={GOLD} />;
  return <ShieldSvg color={SILVER} />;
}

interface LeaderboardListItem {
  ReferrerName: string;
  enrollmentGenerated: number;
  badge: string;
  currectUser?: boolean;
}

interface LeaderboardApiData {
  totalRecords?: number;
  list?: LeaderboardListItem[];
}

interface LeaderboardSectionProps {
  data?: unknown;
  leaderboardData?: LeaderboardApiData | null;
}

export default function LeaderboardSection({ leaderboardData }: LeaderboardSectionProps = {}) {
  const apiEntries =
    leaderboardData?.list
      ?.slice(0, 5)
      .map((item, idx) => ({
        name: item.ReferrerName,
        tier: item.badge,
        rank: idx + 1,
      })) || [];

  const entries = apiEntries.length > 0 ? apiEntries.slice(0,5) : [];

  // Determine the current user's referral count (if present in the API list)
  // so we can show unlocked vs. faded milestone badges.
  const currentUserCount =
    leaderboardData?.list?.find((item) => item.currectUser)?.enrollmentGenerated ?? 0;

  return (
    <section className="overflow-hidden bg-[#F5F7FB] py-10 sm:py-12 md:py-16">
      <div className="mx-auto w-full max-w-[1100px] px-4 sm:px-3 md:px-8 xl:px-10">
        <div className="text-center">
          <h2 className="text-[#1E3A70] text-[22px] leading-[1.15] font-bold tracking-[-0.03em] sm:text-[26px] md:text-[30px] lg:text-[38px]">
            {HEADING}
          </h2>
          <p className="mt-2 text-[#444444] text-[13px] leading-[1.5] font-normal sm:text-xs md:text-[15px] lg:text-base">
            {SUB_HEADING}
          </p>
        </div>

        <div className="mt-7 flex flex-col gap-5 sm:mt-9 sm:gap-6 lg:flex-row">
          {/* Leaderboard card */}
          <div className="flex-1 rounded-[20px] border border-[#E4E7EC] bg-[#FBFBFC] px-4 py-5 shadow-[0px_4px_18px_rgba(15,23,42,0.08)] md:px-5 md:py-6">
            <div className="flex items-center gap-3 mb-4 sm:mb-5">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M7 4h10v5a5 5 0 0 1-10 0V4z" stroke="#FFC907" strokeWidth="1.8" strokeLinecap="round" />
                <path d="M5 5H3v2a3 3 0 0 0 3 3" stroke="#FFC907" strokeWidth="1.8" strokeLinecap="round" />
                <path d="M19 5h2v2a3 3 0 0 1-3 3" stroke="#FFC907" strokeWidth="1.8" strokeLinecap="round" />
                <path d="M10 14h4v3h-4z" stroke="#FFC907" strokeWidth="1.8" strokeLinecap="round" />
                <path d="M8 20h8" stroke="#FFC907" strokeWidth="1.8" strokeLinecap="round" />
                <path d="M12 17v3" stroke="#FFC907" strokeWidth="1.8" strokeLinecap="round" />
              </svg>
              <span className="text-[#223B74] text-[17px] font-bold tracking-[-0.02em] sm:text-[19px] md:text-[21px] lg:text-[24px]">
                {LEADERBOARD_LABEL}
              </span>
            </div>

            <ul className="space-y-2 sm:space-y-2.5">
              {entries && entries.map((entry) => {
                const hasBadge = !!entry.tier && !!badgeStyle[entry.tier];
                const style = hasBadge ? getBadgeStyle(entry.tier) : FALLBACK_BADGE_STYLE;
                return (
                  <li
                    key={`${entry.rank}-${entry.name}`}
                    className="flex items-center justify-between gap-3 rounded-[14px] bg-[#F4F4F6] px-3 py-2.5 sm:px-4 sm:py-3"
                  >
                    <div className="flex min-w-0 items-center gap-3">
                      <RankIcon tier={entry.tier} />
                      <span className="truncate text-[14px] font-medium text-[#163A77] tracking-[-0.01em] sm:text-[15px] md:text-[16px] lg:text-[17px]">
                        {entry.name}
                      </span>
                    </div>
                    {hasBadge ? (
                      <span
                        className="shrink-0 min-w-[72px] rounded-full px-3 py-1 text-center text-[11px] font-bold sm:min-w-[80px] sm:px-3.5 sm:py-1.5 sm:text-[12px] md:min-w-[88px] md:text-[13px] lg:min-w-[96px] lg:text-[14px]"
                        style={{
                          backgroundColor: style.bg,
                          color: style.text,
                        }}
                      >
                        {getBadgeLabel(entry.tier)}
                      </span>
                    ) : (
                      <span className="shrink-0 text-[11px] font-medium italic text-[#90a1b9] sm:text-[12px] md:text-[13px] lg:text-[14px]">
                        Not Available
                      </span>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Milestone Badges card */}
          <div className="flex-1 rounded-[20px] border border-[#E4E7EC] bg-[#FBFBFC] px-4 py-5 shadow-[0px_4px_18px_rgba(15,23,42,0.08)] md:px-5 md:py-6">
            <div className="flex items-center gap-3 mb-4 sm:mb-5">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 2l3 6.3 6.9.9-5 4.9 1.2 6.9L12 17.8 5.9 21l1.2-6.9L2.1 9.2l6.9-.9L12 2z"
                  stroke="#FFC907"
                  strokeWidth="1.8"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="text-[#223B74] text-[17px] font-bold tracking-[-0.02em] sm:text-[19px] md:text-[21px] lg:text-[24px]">
                {MILESTONE_LABEL}
              </span>
            </div>

            <div className="grid grid-cols-5 gap-1 sm:gap-2 md:gap-2.5">
              {milestones && milestones.map((m) => (
                <div
                  key={m.label}
                  className="flex flex-col items-center gap-1 min-w-0 rounded-[12px] border border-[#D9DEE8] bg-white px-1 py-2 sm:gap-0 sm:px-2 sm:py-1.5"
                >
                  <img
                    src={m.unlocked}
                    alt={m.label.replace('\n', ' ')}
                    className="h-8 w-8 object-contain sm:h-9 sm:w-7 md:h-12 md:w-12 lg:h-[52px] lg:w-[52px]"
                  />
                  <span className="w-full text-center text-[9px] font-medium leading-[1.2] text-[#223B74] whitespace-pre-line sm:text-[7px] md:text-[12px] lg:text-[13px]">
                    {m.label}
                  </span>
                </div>
              ))}
            </div>

            <ul className="mt-5 mb-5 space-y-2.5 sm:mt-6 sm:mb-6 sm:space-y-3">
              {benefitItems.map((item) => (
                <li key={item} className="flex items-center gap-3">
                  <svg width="22" height="22" viewBox="0 0 30 30" fill="none" className="flex-shrink-0">
                    <circle cx="15" cy="15" r="13" stroke="#223B74" strokeWidth="2" />
                    <path
                      d="M9.5 15.5L13 19L20.5 11.5"
                      stroke="#223B74"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span className="text-[13px] text-[#444444] sm:text-[14px] md:text-[15px]">{item}</span>
                </li>
              ))}
            </ul>

            <div className="flex items-center gap-4 rounded-full bg-[#EAF0F3] px-5 py-2.5 sm:gap-5 sm:px-4 sm:py-2 max-w-fit">
              {SHARE_LINKS.map((link) => {
                const isDisabled = link.disabled || !link.url;
                return (
                  <a
                    key={link.name}
                    href={isDisabled ? undefined : link.url}
                    target={isDisabled ? undefined : '_blank'}
                    rel={isDisabled ? undefined : 'noopener noreferrer'}
                    onClick={isDisabled ? (e) => e.preventDefault() : undefined}
                    aria-label={`${link.name}${isDisabled ? ' (disabled)' : ''}`}
                    aria-disabled={isDisabled}
                    className={`inline-flex items-center justify-center rounded-full transition-transform duration-200 ${
                      isDisabled
                        ? 'cursor-not-allowed opacity-50'
                        : 'cursor-pointer hover:scale-110'
                    }`}
                  >
                    <img
                      src={link.icon}
                      alt={link.name}
                      className="h-6 w-6 object-contain sm:h-6 sm:w-6"
                      draggable={false}
                    />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        <div className="mt-7 flex lg:justify-center sm:mt-8">
          <Link
            href="/referral/check-status"
            className="inline-flex w-full max-w-[320px] items-center justify-center gap-2.5 rounded-[14px] bg-[#223B74] px-6 py-3 text-[14px] font-bold text-white shadow-[0px_10px_24px_rgba(34,59,116,0.24)] transition-all duration-300 hover:translate-y-[-2px] hover:bg-[#1A2F5F] sm:w-auto sm:text-[15px] md:text-[16px] lg:min-w-[220px] lg:text-[17px]"
          >
            View My Rank
            <svg width="22" height="22" viewBox="0 0 30 30" fill="none">
              <path d="M7 15H23" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
              <path
                d="M16 8L23 15L16 22"
                stroke="white"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
}
